// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e3b5711a","846":"1ab36f67"}[chunkId] + ".chunk.js";
};